/**
 * Find all elements in which at least one of the specified properties includes the provided query string 
 * @param query The query string
 * @param arr An array of T to filter
 * @param properties The properties of T on which to filter
 * @returns A filtered array of T
 */
export function filterForQuery<T>(query: string, arr: T[], properties: Array<keyof T>): T[] {
    if (query === "") return arr;
    const queryLower = query.toLowerCase();
    return arr.filter(a =>
        properties.some(property => {
            const value = a[property];
            return (typeof value === "string" || typeof value === "number") && value.toString().toLowerCase().includes(queryLower);
        })
    )
}
